import { render, staticRenderFns } from "./StatusHorse.vue?vue&type=template&id=249f7a9e&"
import script from "./StatusHorse.vue?vue&type=script&lang=js&"
export * from "./StatusHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports